import { useEffect, useState } from "react";

const BASE_URL = "https://be-portales.utpl.edu.ec";

const DataFetcher = ({ url, children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔥 helper para imagen
  const getImageUrl = (node, included) => {
    const mediaId = node.relationships?.field_imagen_portada?.data?.id;
    if (!mediaId) return null;

    const media = included?.find(
      (item) => item.type === "media--image" && item.id === mediaId
    );

    const fileId = media?.relationships?.field_media_image?.data?.id;
    if (!fileId) return null;

    const file = included?.find(
      (item) => item.type === "file--file" && item.id === fileId
    );

    return file?.attributes?.uri?.url || null;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!url) throw new Error("URL no proporcionada");

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Error ${response.status}`);
        }

        const json = await response.json();

        const node = json?.data;
        const atributos = node?.attributes;
        const included = json?.included || [];

        if (!atributos) {
          throw new Error("Estructura inesperada de la API");
        }

        // 🔥 Resolver imagen aquí
        const imagePath = getImageUrl(node, included);

        const cleanData = {
          id: node.id,
          titulo: atributos.title,
          precio: atributos.field_precio,
          duracion: atributos.field_duracion,
          inicio: atributos.field_inicio_clases,
          descripcion: atributos.body?.value,
          info1: atributos.field_atributo_1?.processed,
          info2: atributos.field_atributo_2?.processed,
          info3: atributos.field_atributo_3?.processed,
          field_texto_portada: atributos.field_texto_portada,

          // ✅ ahora sí existe
          imagen_portada: imagePath ? BASE_URL + imagePath : "",
        };

        setData(cleanData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error}</p>;

  return children(data);
};

export default DataFetcher;